/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('svgEmbed', {
    template: '',
    bindings: {
      url: '<'
    },
    controller: svgEmbedController
  });

// Expects <svg-embed><img src="xxx.svg"></svg-embed> syntax.
// This will embed the actual contents of the svg into html.
// Doing so will allow us to change colors etc.
svgEmbedController.$inject = ['$element', '$http', '$scope', 'Environment'];
function svgEmbedController($element, $http, $scope, Environment) {
  Environment.get()
    .then(environment => {
    // TODO: GRR: angular tests are REALLY complex with the order of requests
    // and I just can't figure out why some tests fail,
    // so make it so that asset requests don't run on test env >_<
      if(environment === 'test') return;

      $scope.$watch(angular.bind(this, function() {
        return this.url;
      }), function(newValue, oldValue) {
        if(newValue) {
        // Get the svg with html request and embed it directly.
        // If something goes wrong, the img is still there
          $http.get(newValue)
            .then(res => {
              const $el = $(res.data);
              $element.html($el);
            })
            .catch(err => {
              $element.html(`<img src="${newValue}">`);
              console.error(`Could not load ${newValue}`);
            });
        }
      });
    });
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/svg_embed/svg_embed.js